import type { ReactNode, SVGProps } from 'react'

import { cn } from '@repo/ui/lib/utils'

export interface Iphone15ProProps
  extends Omit<SVGProps<SVGSVGElement>, 'children' | 'width' | 'height'> {
  width?: number | string
  height?: number | string
  src?: string
  videoSrc?: string
  children?: ReactNode
}

export function Iphone15Pro({
  width,
  height,
  src,
  videoSrc,
  className,
  children,
  ...props
}: Iphone15ProProps) {
  return (
    <div
      className={cn('relative block w-full', className)}
      style={{
        width: width ?? undefined,
        height: height ?? undefined,
        aspectRatio: '433 / 882',
      }}
    >
      <svg
        viewBox="0 0 433 882"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        className="absolute inset-0 size-full"
        {...props}
      >
        <title>iPhone 15 Pro</title>
        <path
          d="M2 73C2 32.6832 34.6832 0 75 0H358C398.317 0 431 32.6832 431 73V809C431 849.317 398.317 882 358 882H75C34.6832 882 2 849.317 2 809V73Z"
          className="fill-[#1a1a1a] dark:fill-[#0a0a0a]"
        />
        <path
          d="M0 171C0 170.448 0.447715 170 1 170H3V204H1C0.447715 204 0 203.552 0 203V171Z"
          className="fill-[#1a1a1a] dark:fill-[#0a0a0a]"
        />
        <path
          d="M1 234C1 233.448 1.44772 233 2 233H3.5V300H2C1.44772 300 1 299.552 1 299V234Z"
          className="fill-[#1a1a1a] dark:fill-[#0a0a0a]"
        />
        <path
          d="M1 319C1 318.448 1.44772 318 2 318H3.5V385H2C1.44772 385 1 384.552 1 384V319Z"
          className="fill-[#1a1a1a] dark:fill-[#0a0a0a]"
        />
        <path
          d="M430 279H432C432.552 279 433 279.448 433 280V384C433 384.552 432.552 385 432 385H430V279Z"
          className="fill-[#1a1a1a] dark:fill-[#0a0a0a]"
        />
        <path
          d="M6 74C6 35.3401 37.3401 4 76 4H357C395.66 4 427 35.3401 427 74V808C427 846.66 395.66 878 357 878H76C37.3401 878 6 846.66 6 808V74Z"
          className="fill-black"
        />
        <path
          d="M16 76C16 42.8629 42.8629 16 76 16H357C390.137 16 417 42.8629 417 76V806C417 839.137 390.137 866 357 866H76C42.8629 866 16 839.137 16 806V76Z"
          className="fill-[#0a0a0a]"
        />
        <path
          d="M154 48.5C154 38.2827 162.283 30 172.5 30H260.5C270.717 30 279 38.2827 279 48.5C279 58.7173 270.717 67 260.5 67H172.5C162.283 67 154 58.7173 154 48.5Z"
          className="fill-black"
        />
        <circle cx="249.5" cy="48.5" r="6.5" className="fill-[#1a1a1a]" />
      </svg>
      <div
        className="absolute overflow-hidden bg-black"
        style={{
          left: `${(16 / 433) * 100}%`,
          top: `${(16 / 882) * 100}%`,
          width: `${(401 / 433) * 100}%`,
          height: `${(850 / 882) * 100}%`,
          borderRadius: '11.36%',
        }}
      >
        {children ??
          (videoSrc ? (
            <video
              src={videoSrc}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : src ? (
            // biome-ignore lint/performance/noImgElement: packages/ui has no next/image dependency
            <img
              src={src}
              alt=""
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : null)}
      </div>
    </div>
  )
}
